/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimOrganizationsResponse,
  ContactOrganization,
  CreateOrganizationRequest,
  GetOrganizationProperties200Response,
  LinkOrganizationContactRequest,
  LinkOrganizationProperty201Response,
  LinkOrganizationPropertyRequest,
  ListOrganizationsResponse,
  Organization,
  OrganizationContactsResponse,
  Problem,
  UpdateOrganizationRequest,
} from '../models/index';
import {
    ClaimOrganizationsResponseFromJSON,
    ClaimOrganizationsResponseToJSON,
    ContactOrganizationFromJSON,
    ContactOrganizationToJSON,
    CreateOrganizationRequestFromJSON,
    CreateOrganizationRequestToJSON,
    GetOrganizationProperties200ResponseFromJSON,
    GetOrganizationProperties200ResponseToJSON,
    LinkOrganizationContactRequestFromJSON,
    LinkOrganizationContactRequestToJSON,
    LinkOrganizationProperty201ResponseFromJSON,
    LinkOrganizationProperty201ResponseToJSON,
    LinkOrganizationPropertyRequestFromJSON,
    LinkOrganizationPropertyRequestToJSON,
    ListOrganizationsResponseFromJSON,
    ListOrganizationsResponseToJSON,
    OrganizationFromJSON,
    OrganizationToJSON,
    OrganizationContactsResponseFromJSON,
    OrganizationContactsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateOrganizationRequestFromJSON,
    UpdateOrganizationRequestToJSON,
} from '../models/index';

export interface CreateOrganizationOperationRequest {
    createOrganizationRequest: CreateOrganizationRequest;
}

export interface DeleteOrganizationRequest {
    id: number;
}

export interface GetOrganizationRequest {
    id: number;
}

export interface GetOrganizationClaimsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetOrganizationContactsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetOrganizationPropertiesRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface LinkOrganizationContactOperationRequest {
    id: number;
    linkOrganizationContactRequest: LinkOrganizationContactRequest;
}

export interface LinkOrganizationPropertyOperationRequest {
    id: number;
    linkOrganizationPropertyRequest: LinkOrganizationPropertyRequest;
}

export interface ListOrganizationsRequest {
    orgType?: string;
    search?: string;
    limit?: number;
    offset?: number;
}

export interface UnlinkOrganizationContactRequest {
    id: number;
    contactId: number;
}

export interface UnlinkOrganizationPropertyRequest {
    id: number;
    propertyId: number;
}

export interface UpdateOrganizationOperationRequest {
    id: number;
    updateOrganizationRequest: UpdateOrganizationRequest;
}

/**
 * OrganizationsApi - interface
 * 
 * @export
 * @interface OrganizationsApiInterface
 */
export interface OrganizationsApiInterface {
    /**
     * 
     * @summary Create an organization
     * @param {CreateOrganizationRequest} createOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    createOrganizationRaw(requestParameters: CreateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>>;

    /**
     * Create an organization
     */
    createOrganization(requestParameters: CreateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization>;

    /**
     * 
     * @summary Delete an organization
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    deleteOrganizationRaw(requestParameters: DeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete an organization
     */
    deleteOrganization(requestParameters: DeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get organization by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationRaw(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>>;

    /**
     * Get organization by ID
     */
    getOrganization(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization>;

    /**
     * 
     * @summary Get all claims linked to an organization
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationClaimsRaw(requestParameters: GetOrganizationClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganizationsResponse>>;

    /**
     * Get all claims linked to an organization
     */
    getOrganizationClaims(requestParameters: GetOrganizationClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganizationsResponse>;

    /**
     * 
     * @summary List contacts for an organization
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationContactsRaw(requestParameters: GetOrganizationContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationContactsResponse>>;

    /**
     * List contacts for an organization
     */
    getOrganizationContacts(requestParameters: GetOrganizationContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationContactsResponse>;

    /**
     * 
     * @summary List properties linked to an organization
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationPropertiesRaw(requestParameters: GetOrganizationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationProperties200Response>>;

    /**
     * List properties linked to an organization
     */
    getOrganizationProperties(requestParameters: GetOrganizationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationProperties200Response>;

    /**
     * 
     * @summary Link a contact to an organization
     * @param {number} id 
     * @param {LinkOrganizationContactRequest} linkOrganizationContactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    linkOrganizationContactRaw(requestParameters: LinkOrganizationContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganization>>;

    /**
     * Link a contact to an organization
     */
    linkOrganizationContact(requestParameters: LinkOrganizationContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganization>;

    /**
     * 
     * @summary Link a property to an organization
     * @param {number} id 
     * @param {LinkOrganizationPropertyRequest} linkOrganizationPropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    linkOrganizationPropertyRaw(requestParameters: LinkOrganizationPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkOrganizationProperty201Response>>;

    /**
     * Link a property to an organization
     */
    linkOrganizationProperty(requestParameters: LinkOrganizationPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkOrganizationProperty201Response>;

    /**
     * 
     * @summary List organizations
     * @param {string} [orgType] Filter by organization type (e.g. insurance_company, contracting_company)
     * @param {string} [search] Search by name
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    listOrganizationsRaw(requestParameters: ListOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOrganizationsResponse>>;

    /**
     * List organizations
     */
    listOrganizations(requestParameters: ListOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOrganizationsResponse>;

    /**
     * 
     * @summary Unlink a contact from an organization
     * @param {number} id 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    unlinkOrganizationContactRaw(requestParameters: UnlinkOrganizationContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink a contact from an organization
     */
    unlinkOrganizationContact(requestParameters: UnlinkOrganizationContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink a property from an organization
     * @param {number} id 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    unlinkOrganizationPropertyRaw(requestParameters: UnlinkOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink a property from an organization
     */
    unlinkOrganizationProperty(requestParameters: UnlinkOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update an organization
     * @param {number} id 
     * @param {UpdateOrganizationRequest} updateOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationRaw(requestParameters: UpdateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>>;

    /**
     * Update an organization
     */
    updateOrganization(requestParameters: UpdateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization>;

}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI implements OrganizationsApiInterface {

    /**
     * Create an organization
     */
    async createOrganizationRaw(requestParameters: CreateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>> {
        if (requestParameters['createOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationRequest',
                'Required parameter "createOrganizationRequest" was null or undefined when calling createOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationRequestToJSON(requestParameters['createOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
    }

    /**
     * Create an organization
     */
    async createOrganization(requestParameters: CreateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization> {
        const response = await this.createOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an organization
     */
    async deleteOrganizationRaw(requestParameters: DeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an organization
     */
    async deleteOrganization(requestParameters: DeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Get organization by ID
     */
    async getOrganizationRaw(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
    }

    /**
     * Get organization by ID
     */
    async getOrganization(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization> {
        const response = await this.getOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claims linked to an organization
     */
    async getOrganizationClaimsRaw(requestParameters: GetOrganizationClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganizationsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/claims`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimOrganizationsResponseFromJSON(jsonValue));
    }

    /**
     * Get all claims linked to an organization
     */
    async getOrganizationClaims(requestParameters: GetOrganizationClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganizationsResponse> {
        const response = await this.getOrganizationClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List contacts for an organization
     */
    async getOrganizationContactsRaw(requestParameters: GetOrganizationContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationContactsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/contacts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationContactsResponseFromJSON(jsonValue));
    }

    /**
     * List contacts for an organization
     */
    async getOrganizationContacts(requestParameters: GetOrganizationContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationContactsResponse> {
        const response = await this.getOrganizationContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List properties linked to an organization
     */
    async getOrganizationPropertiesRaw(requestParameters: GetOrganizationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationProperties200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationProperties().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/properties`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationProperties200ResponseFromJSON(jsonValue));
    }

    /**
     * List properties linked to an organization
     */
    async getOrganizationProperties(requestParameters: GetOrganizationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationProperties200Response> {
        const response = await this.getOrganizationPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a contact to an organization
     */
    async linkOrganizationContactRaw(requestParameters: LinkOrganizationContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkOrganizationContact().'
            );
        }

        if (requestParameters['linkOrganizationContactRequest'] == null) {
            throw new runtime.RequiredError(
                'linkOrganizationContactRequest',
                'Required parameter "linkOrganizationContactRequest" was null or undefined when calling linkOrganizationContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/contacts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkOrganizationContactRequestToJSON(requestParameters['linkOrganizationContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactOrganizationFromJSON(jsonValue));
    }

    /**
     * Link a contact to an organization
     */
    async linkOrganizationContact(requestParameters: LinkOrganizationContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactOrganization> {
        const response = await this.linkOrganizationContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a property to an organization
     */
    async linkOrganizationPropertyRaw(requestParameters: LinkOrganizationPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkOrganizationProperty201Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkOrganizationProperty().'
            );
        }

        if (requestParameters['linkOrganizationPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'linkOrganizationPropertyRequest',
                'Required parameter "linkOrganizationPropertyRequest" was null or undefined when calling linkOrganizationProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/properties`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkOrganizationPropertyRequestToJSON(requestParameters['linkOrganizationPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkOrganizationProperty201ResponseFromJSON(jsonValue));
    }

    /**
     * Link a property to an organization
     */
    async linkOrganizationProperty(requestParameters: LinkOrganizationPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkOrganizationProperty201Response> {
        const response = await this.linkOrganizationPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List organizations
     */
    async listOrganizationsRaw(requestParameters: ListOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOrganizationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['orgType'] != null) {
            queryParameters['orgType'] = requestParameters['orgType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOrganizationsResponseFromJSON(jsonValue));
    }

    /**
     * List organizations
     */
    async listOrganizations(requestParameters: ListOrganizationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOrganizationsResponse> {
        const response = await this.listOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlink a contact from an organization
     */
    async unlinkOrganizationContactRaw(requestParameters: UnlinkOrganizationContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkOrganizationContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling unlinkOrganizationContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/contacts/{contactId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink a contact from an organization
     */
    async unlinkOrganizationContact(requestParameters: UnlinkOrganizationContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkOrganizationContactRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink a property from an organization
     */
    async unlinkOrganizationPropertyRaw(requestParameters: UnlinkOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkOrganizationProperty().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling unlinkOrganizationProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}/properties/{propertyId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink a property from an organization
     */
    async unlinkOrganizationProperty(requestParameters: UnlinkOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkOrganizationPropertyRaw(requestParameters, initOverrides);
    }

    /**
     * Update an organization
     */
    async updateOrganizationRaw(requestParameters: UpdateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOrganization().'
            );
        }

        if (requestParameters['updateOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationRequest',
                'Required parameter "updateOrganizationRequest" was null or undefined when calling updateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationRequestToJSON(requestParameters['updateOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
    }

    /**
     * Update an organization
     */
    async updateOrganization(requestParameters: UpdateOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization> {
        const response = await this.updateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
